import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { formatNumber, formatCurrency } from "utils/currencyFormat";
import { formatDayMonth } from "utils/formatDate";
import { getListNhanVay, updateDataSearch } from "../../actions/NhanVay/";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const TableNhanVay = ({
  listNhanVay,
  quyenGhiChu,
  quyenGiaHanHopDong,
  quyenGiaHanNgayTra,
  quyenSuaNhanVay,
  quyenTatToan,
  quyenXemChiTietHopDong,
  quyenXemChiTietKhachHang,
  quyenTraBotGoc,
  quyenTralai,
  quyenXoa,
  quyenThemMoi,
  quyenInHopDong,
  quyenXuatExcel,
  quyenSuaTienTatToan,
  choVay,
  setChoVay,
  objThietLapHienThiDanhSach,
  quyenVayThem,
  printThuChi,
  handleShowTraLai,
}) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  useEffect(() => {
    dispatch(getListNhanVay(dataSearch));
  }, []);

  const loadPage = () => {
    getListNhanVay(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListNhanVay(dataSearch));
    loadPage(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = listNhanVay.objList.TongBanGhi;

  return (
    <div className="Left808x200 Table-main-new">
      <div className="loading-page1">
        <div
          className={
            "loader loader-default " +
            (listNhanVay.getListNhanVayLoading ? "is-active" : "")
          }
        ></div>
      </div>
      <div
        className={
          quyenThemMoi === true &&
          quyenInHopDong === true &&
          quyenXuatExcel === true
            ? "table-mobile sticky-table-bh2 table-mobile-hover table-mobile1"
            : "table-mobile sticky-table-bh2 table-mobile-hover table-mobile1"
        }
      >
        <div className="custom-table-wrapper">
          <div className="table-headers">
            {objThietLapHienThiDanhSach.IsAnSTT != true && (
              <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                <p className="text-center">
                  STT
                  <br />{" "}
                  <span className="red">
                    [ {listNhanVay.objList.TongBanGhi} ]
                  </span>
                </p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-header flex-basis-14 flex-basis-15-6-sm">
                <p>Mã nhận vay</p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div className="custom-table-header flex-basis-12 flex-basis-11-8-sm">
                <p>Tên chủ nợ</p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnTSTheChap != true && (
              <div className="custom-table-header flex-basis-10 flex-basis-9-sm">
                <p>TS thế chấp</p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnSoTienVay != true && (
              <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                <p className="text-right">
                  Số tiền vay
                  <br />
                  <PopoversBootrap
                    contentText={formatNumber(
                      listNhanVay.objList.TongSoTienVay
                    )}
                    trigger={["hover", "focus"]}
                    placement={"bottom"}
                  >
                    <span className="color-do-bold">
                      {formatCurrency(listNhanVay.objList.TongSoTienVay)}
                    </span>
                  </PopoversBootrap>
                </p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnLaiPhaiTra != true && (
              <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                <p className="text-right">
                  Lãi phải trả
                  <br />
                  <PopoversBootrap
                    contentText={formatNumber(
                      listNhanVay.objList.TongLaiPhaiTra
                    )}
                    trigger={["hover", "focus"]}
                    placement={"bottom"}
                  >
                    <span className="color7-bold">
                      {formatCurrency(listNhanVay.objList.TongLaiPhaiTra)}
                    </span>
                  </PopoversBootrap>
                </p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnLaiDenHomNay != true && (
              <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                <p className="text-right">
                  Lãi đến hôm nay
                  <br />
                  <PopoversBootrap
                    contentText={formatNumber(
                      listNhanVay.objList.TongLaiDenHomNay
                    )}
                    trigger={["hover", "focus"]}
                    placement={"bottom"}
                  >
                    <span className="color-cam-bold">
                      {formatCurrency(listNhanVay.objList.TongLaiDenHomNay)}
                    </span>
                  </PopoversBootrap>
                </p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnTienDaTra != true && (
              <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                <p className="text-right">
                  Tiền đã trả
                  <br />
                  <PopoversBootrap
                    contentText={formatNumber(
                      listNhanVay.objList.TongTienDaTra
                    )}
                    trigger={["hover", "focus"]}
                    placement={"bottom"}
                  >
                    <span className="color-xanh-bold">
                      {formatCurrency(listNhanVay.objList.TongTienDaTra)}
                    </span>
                  </PopoversBootrap>
                </p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
              <div className="custom-table-header flex-basis-8 flex-basis-12-sm">
                <p className="tab-header text-center">Trạng thái</p>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnChucNang != true && (
              <div className="custom-table-header flex-basis-16 flex-basis-15-6-sm">
                <p className="tab-header">Chức năng</p>
              </div>
            )}
          </div>

          <div className="custom-table-body">
            <ContentTable
              listdata={listNhanVay.objList.List}
              quyenGhiChu={quyenGhiChu}
              quyenGiaHanHopDong={quyenGiaHanHopDong}
              quyenGiaHanNgayTra={quyenGiaHanNgayTra}
              quyenSuaNhanVay={quyenSuaNhanVay}
              quyenTatToan={quyenTatToan}
              quyenXemChiTietHopDong={quyenXemChiTietHopDong}
              quyenXemChiTietKhachHang={quyenXemChiTietKhachHang}
              quyenTraBotGoc={quyenTraBotGoc}
              quyenVayThem={quyenVayThem}
              quyenTralai={quyenTralai}
              quyenXoa={quyenXoa}
              quyenSuaTienTatToan={quyenSuaTienTatToan}
              choVay={choVay}
              setChoVay={setChoVay}
              objThietLapHienThiDanhSach={objThietLapHienThiDanhSach}
              printThuChi={printThuChi}
              handleShowTraLai={handleShowTraLai}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
